var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkBankAccount = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 145,
    viewBox: "0 0 167 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.883 128.189H148.33V127.16H166.883V128.189Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.883 134.155H148.33V133.126H166.883V134.155Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.883 140.119H148.33V139.09H166.883V140.119Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167 12.4282H13.918V119.809H167V12.4282Z",
    fill: "#6BB6FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.082 0.811035H0V105.874H153.082V0.811035Z",
    fill: "#006EF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.469 42.2872V50.3236C133.469 51.4596 132.548 52.3816 131.412 52.3816H98.2124C97.0764 52.3816 96.1544 51.4596 96.1544 50.3236V42.2872C96.1544 41.1492 97.0764 40.2292 98.2124 40.2292H131.412C132.548 40.2292 133.469 41.1492 133.469 42.2872V42.2872Z",
    fill: "#6BB6FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.47 42.2872V50.3236C133.47 51.4596 132.548 52.3816 131.412 52.3816H114.812V40.2292H131.412C132.548 40.2292 133.47 41.1492 133.47 42.2872V42.2872Z",
    fill: "#F0F8FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.082 12.4282H0V29.3324H153.082V12.4282Z",
    fill: "#091F83"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167 29.3325H153.082V46.2367H167V29.3325Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 105.891H76.542L38.27 144.161L0 105.891Z",
    fill: "#FFB257"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.082 105.874H76.542L114.812 67.6023L153.082 105.874Z",
    fill: "#00EC25"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6688 67.6023H27.871V105.872H48.6688V67.6023Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.211 119.809H104.413V144.161H125.211V119.809Z",
    fill: "#006EF5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.211 105.891H104.413V119.809H125.211V105.891Z",
    fill: "#091F83"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6624 39.7829H17.8796V38.7539H58.6624V39.7829Z",
    fill: "#F0F8FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6624 46.5803H17.8796V45.5513H58.6624V46.5803Z",
    fill: "#F0F8FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.27 53.3779H17.8796V52.3489H38.27V53.3779Z",
    fill: "#F0F8FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.747 37.2475L114.81 50.1149L109.484 44.8562L110.785 43.5381L114.805 47.5074L126.441 35.9343L127.747 37.2475Z",
    fill: "#232323"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkBankAccount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LinkBankAccount.f6673d8e47f415f261d186350fc1d437.svg";